import React from 'react';
import colors from '../../../scss/colors';

function ValidationErrorLabel(props) {
  const { message, color = colors.RED_ERROR, fontSize = '12px' } = props;

  return <span style={{ color, fontSize }}>{message}</span>;
}

export default ValidationErrorLabel;
